
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[legalPage]",
      function () {
        return require("private-next-pages/legal/[legalPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[legalPage]"])
      });
    }
  